import { VStack } from "@gluestack-ui/themed";
import { EmptyState } from "@repo/core/components/layout/EmptyState";
import { InstallmentOption } from "./components/InstallmentOption";
import { InterestTypeSelector } from "./components/InterestTypeSelector";
import { InstallmentsListProps } from "./types";
import { useInstallmentsListController } from "./controller";
import { InstallmentOptionsLoader } from "./loading";
import { InterestTypeEnum } from "@repo/core/enums/installments";

export const InstallmentsList = (props: InstallmentsListProps) => {
  const {
    isFetching,
    installmentOptions,
    selectedInterestType,
    selectedInstallmentId,
    onInstallmentChange,
    onInterestTypeChange
  } = useInstallmentsListController(props);

  if (isFetching) {
    return <InstallmentOptionsLoader />;
  }

  if (!installmentOptions || installmentOptions.length === 0) {
    return (
      <EmptyState flex={1} text="Nenhuma opção de parcelamento disponível." />
    );
  }

  return (
    <VStack space="lg">
      <InterestTypeSelector
        selectedInterestType={selectedInterestType}
        onInterestTypeChange={onInterestTypeChange}
        isLoading={isFetching}
      />

      <VStack space="md">
        {installmentOptions.map((option, index) => (
          <InstallmentOption
            key={`${option.intPrazo}-${index}`}
            installments={option.intPrazo}
            installmentValue={option.dblValorPrestacao}
            totalValue={option.intPrazo * option.dblValorPrestacao}
            onPress={() => onInstallmentChange(index)}
            isBestOption={
              index === 0 &&
              selectedInterestType === InterestTypeEnum.WITH_INTEREST
            }
            isSelected={selectedInstallmentId === index}
          />
        ))}
      </VStack>
    </VStack>
  );
};

export default InstallmentsList;
